import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Building2 } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { PageHeader, Loading } from "../components/common";
import { BackupsPanel } from "../components/platform/BackupsPanel";
import { GoogleOAuthPanel } from "../components/platform/GoogleOAuthPanel";
import { IntegrityPanel, DeletedPanel } from "../components/platform/IntegrityPanel";

export default function PlatformAdmin() {
  const { t } = useLang();
  const { user } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { if (user.platform_admin) api.get("/platform/overview").then((r) => setD(r.data)); }, [user.platform_admin]);
  if (!user.platform_admin) return <Navigate to="/" replace />;
  if (!d) return <Loading />;
  const stats = [["companies", t("Companies", "Empresas"), d.companies], ["active", t("Active", "Activas"), d.active], ["suspended", t("Suspended", "Suspendidas"), d.suspended],
    ["users", t("Users", "Usuarios"), d.users], ["customers", t("Customers", "Clientes"), d.customers], ["invites", t("Pending invitations", "Invitaciones pendientes"), d.pending_invites]];
  return (
    <>
      <PageHeader title={t("Platform Administration", "Administración de la plataforma")} subtitle="Platform Super Admin"
        actions={<Link to="/companies" className="btn-primary" data-testid="platform-companies-btn"><Building2 className="w-5 h-5" /> {t("Manage companies", "Administrar empresas")}</Link>} />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3" data-testid="platform-overview">
        {stats.map(([k, l, v]) => (
          <div key={k} className="card p-4"><div className="text-sm text-slate-500">{l}</div><div className="text-3xl font-extrabold mono" data-testid={`platform-stat-${k}`}>{v}</div></div>
        ))}
      </div>
      <div className="card p-4 mt-4 text-sm" data-testid="platform-plans">
        <b>{t("Plans", "Planes")}:</b> Basic {d.plans.basic} · Pro {d.plans.pro} · Business {d.plans.business}
      </div>
      <h2 className="text-base md:text-lg font-extrabold mt-8 mb-3" data-testid="data-protection-title">{t("Data protection", "Protección de datos")}</h2>
      <div className="grid lg:grid-cols-2 gap-4 items-start">
        <BackupsPanel />
        <div className="grid gap-4"><IntegrityPanel /><DeletedPanel /></div>
      </div>
      <h2 className="text-base md:text-lg font-extrabold mt-8 mb-3">{t("Platform integrations", "Integraciones de la plataforma")}</h2>
      <div className="grid lg:grid-cols-2 gap-4 items-start"><GoogleOAuthPanel /></div>
    </>
  );
}
